import { DocumentManualForm } from "./DocumentManualForm.js";

/** Manual creation entry point. The form is shared with the edit page;
 * passing no `existing` prop puts it into create mode. */
export function DocumentManualNewPage(): JSX.Element {
  return <DocumentManualForm />;
}
